import { apiGet, apiPost, queryString, type ApiResult } from "./client";
import type { Role, UserAccount } from "./types";

export interface NewUser {
  username: string;
  displayName: string;
  role: Role;
  teacherId: string | null;
  initialPassword: string;
}

export async function fetchUsers(role: Role | null): Promise<ApiResult<UserAccount[]>> {
  return apiGet<UserAccount[]>("/users" + queryString({ role }));
}

export async function createUser(user: NewUser): Promise<ApiResult<UserAccount>> {
  return apiPost<UserAccount>("/users", user);
}

export async function setUserActive(id: string, active: boolean): Promise<ApiResult<UserAccount>> {
  const action: string = active ? "activate" : "deactivate";
  return apiPost<UserAccount>(`/users/${id}/${action}`, undefined);
}

export async function resetPassword(id: string, newPassword: string): Promise<ApiResult<null>> {
  return apiPost<null>(`/users/${id}/reset-password`, { newPassword });
}
